<template>
  <v-container grid-list-md>
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <base-card
          title="Contacts"
          icon="contacts"
        >
          <v-flex xs12>
            <blockquote class="blockquote bg-light">
              <h3>
                <a
                  href="https://www.researchgate.net/profile/Jian_Ren2/publications"
                  target="_blank"
                >
                  Jian Ren
                </a>
              </h3>
              <a href="mailto:renjian.sysu@gmail.com">
                <v-icon>email</v-icon> renjian.sysu@gmail.com
              </a>
              <p class="mb-0"><i>Professor of Bioinformatics</i></p>
              <footer class="blockquote-footer">
                School of Life Sciences, Cancer Center, Sun Yat-sen University,
                Guangzhou 510060, China
              </footer>
            </blockquote>
          </v-flex>
          <v-flex xs12>
            <blockquote class="blockquote bg-light">
              <h3>
                <a
                  href="https://www.researchgate.net/profile/Zhixiang_Zuo/publications"
                  target="_blank"
                >
                  Zhixiang Zuo
                </a>
              </h3>
              <a href="mailto:zuozhx@sysucc.org.cn">
                <v-icon>email</v-icon> zuozhx@sysucc.org.cn
              </a>
              <p class="mb-0"><i>Associate Professor of Cancer Genomics</i></p>
              <footer class="blockquote-footer">
                Cancer Center, Sun Yat-sen University, Guangzhou 510060, China
              </footer>
            </blockquote>
          </v-flex>
          <v-flex xs12>
            <blockquote class="blockquote bg-light">
              <h3>
                <a
                  href="https://www.researchgate.net/profile/Qi_Zhao11?ev=hdr_xprf"
                  target="_blank"
                >
                  Qi Zhao
                </a>
              </h3>
              <a href="mailto:zhaoqi@sysucc.org.cn">
                <v-icon>email</v-icon> zhaoqi@sysucc.org.cn
              </a>
              <p class="mb-0"><i>Assistant professor of cancer bioinformatics</i></p>
              <footer class="blockquote-footer">
                Cancer Center, Sun Yat-sen University, Guangzhou 510060, China
              </footer>
            </blockquote>
          </v-flex>
        </base-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Contact',
};
</script>

<style lang="scss" scoped>
  .blockquote {
    border-left: solid .5rem var(--v-primary-base);
    padding: 1rem 2rem;
  }
</style>
